import { Stack, Typography } from "@mui/material";
import { IResourceComponentsProps, useShow, useTranslate } from "@refinedev/core";
import { DateField, EmailField, NumberField, Show, TextFieldComponent as TextField } from "@refinedev/mui";

import { DATE_TIME_FORMAT } from "@/Environment";
import { ContentLoadingIndicator } from "@/components/information/ContentLoadingIndicator";

export const UserShow: React.FC<IResourceComponentsProps> = () => {
  const translate = useTranslate();
  const { queryResult } = useShow();
  const { data, isLoading } = queryResult;

  const record = data?.data;

  return (
    <Show isLoading={isLoading} canEdit={false} canDelete={false}>
      {isLoading ? (
        <ContentLoadingIndicator fill />
      ) : (
        <Stack gap={1}>
          <img src={record?.photoUrl} alt={translate("user.field.photo")} width={64} />
          <Typography variant="body1" fontWeight="bold">
            {translate("users.fields.id")}
          </Typography>
          <NumberField value={record?.id ?? ""} />
          <Typography variant="body1" fontWeight="bold">
            {translate("users.fields.identityProviderIds")}
          </Typography>
          <TextField value={record?.identityProviderIds} />
          <Typography variant="body1" fontWeight="bold">
            {translate("users.fields.email")}
          </Typography>
          <EmailField value={record?.email} />
          <Typography variant="body1" fontWeight="bold">
            {translate("users.fields.name")}
          </Typography>
          <TextField value={record?.name} />{" "}
          <Typography variant="body1" fontWeight="bold">
            {translate("users.fields.createdOn")}
          </Typography>
          <DateField value={record?.createdOn} format={DATE_TIME_FORMAT} />
          <Typography variant="body1" fontWeight="bold">
            {translate("users.fields.updatedOn")}
          </Typography>
          <DateField value={record?.updatedOn} format={DATE_TIME_FORMAT} />
        </Stack>
      )}
    </Show>
  );
};
